import { Localized } from "@fluent/react";
import { LoadingButton } from "@mui/lab";
import CheckIcon from '@mui/icons-material/Check';
import { ReactNode } from "react";

interface YesButtonProps {
    loading: boolean;
    disabled?: boolean;
    onClick: () => void;
    label?: ReactNode
}

export const YesButton: React.FC<YesButtonProps> = ({ loading, disabled = false, onClick, label }) => {
    return (
        <LoadingButton
            loading={loading}
            disabled={disabled}
            size="small"
            color="success"
            variant="contained"
            startIcon={<CheckIcon />}
            onClick={onClick}
        >
            {label ? label : <Localized id="yes">_yes</Localized>}
        </LoadingButton>
    );
};
